<span *ngIf="rowData.desc && rowData.desc.length <50">{{rowData.desc}}</span>
<span *ngIf="rowData.desc && rowData.desc.length >50" ngbTooltip="{{rowData.desc}}">{{ rowData.desc.length > 50 ?
    ((rowData.desc | slice:0:50) + '...') : rowData.desc }}</span>

<span *ngIf="rowData.description && rowData.description.length <50">{{rowData.description}}</span>
<span *ngIf="rowData.description && rowData.description.length >50" ngbTooltip="{{rowData.description}}">{{
    rowData.description.length > 50 ? ((rowData.description | slice:0:50) + '...') : rowData.description }}</span>